import React, { isValidElement, cloneElement } from "react";
import * as ReactIs from "react-is";
// What the hell does this do!?
export const validateNode = (node, el) => isValidElement(node) || !node ? node : el ? el : `${node}`;
/** Maps over the first level of children. Will ignore fragments until a first non-fragment child is found */
export const mapChildren = (children, fn) => {
    const mapped = React.Children.map(children, (child) => {
        var _a;
        if (ReactIs.isFragment(child)) {
            if (child.props.children) {
                return mapChildren(child.props.children, fn);
            }
        }
        else {
            return (_a = fn(child)) !== null && _a !== void 0 ? _a : undefined;
        }
    });
    if (Array.isArray(mapped)) {
        if (mapped.length === 0)
            return undefined;
        if (mapped.length === 1)
            return mapped[0];
    }
    return mapped;
};
/** Maps over all levels of children */
export const deepMapChildren = (children, fn) => {
    const mapped = React.Children.map(children, (child) => {
        var _a;
        if (isValidElement(child) && child.props.children) {
            child = cloneElement(child, {
                children: deepMapChildren(child.props.children, fn),
            });
        }
        return (_a = fn(child)) !== null && _a !== void 0 ? _a : undefined;
    });
    if (Array.isArray(mapped)) {
        if (mapped.length === 0)
            return undefined;
        if (mapped.length === 1)
            return mapped[0];
    }
    return mapped;
};
//# sourceMappingURL=helpers.js.map